import type { KeyboardEvent } from 'react';
import { BasePriceRuleFormValue } from 'src/interfaces/Template.interface';

export const sanitizeNonNegativeNumericInput = (raw: string): string => {
  if (raw === '') return '';
  const cleaned = raw.replace(/-/g, '').replace(/[^\d.]/g, '');
  const match = cleaned.match(/^\d*\.?\d*/);
  return match ? match[0] : '';
};

export const blockNegativeNumberInput = (event: KeyboardEvent<HTMLInputElement>) => {
  if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
    event.preventDefault();
  }
};

export const isRepricingActive = (rule: BasePriceRuleFormValue) =>
  rule.adjustmentType === 'INCREASE' || rule.adjustmentType === 'DECREASE';

export const isValidNumericString = (raw: string) => {
  const trimmed = String(raw ?? '').trim();
  if (trimmed === '') return false;
  const num = Number(trimmed);
  return Number.isFinite(num) && num >= 0;
};

export const isDefaultValueInvalid = (rule: BasePriceRuleFormValue) =>
  rule.mappingOption === 'DEFAULT' &&
  isRepricingActive(rule) &&
  !isValidNumericString(rule.defaultValue);

export const isMappedFieldInvalid = (rule: BasePriceRuleFormValue) =>
  (rule.mappingOption === 'NATIVE' || rule.mappingOption === 'CUSTOM') &&
  isRepricingActive(rule) &&
  (rule.mappedField === '' || rule.mappedField == null);

export const isAdjustmentValueInvalid = (rule: BasePriceRuleFormValue) =>
  isRepricingActive(rule) && !isValidNumericString(rule.adjustmentValue);

export const isPriceRuleInvalid = (rule: BasePriceRuleFormValue) =>
  isDefaultValueInvalid(rule) ||
  isMappedFieldInvalid(rule) ||
  isAdjustmentValueInvalid(rule);

export const getPriceRuleValidationError = (rules: BasePriceRuleFormValue[]): string | null => {
  for (const rule of rules) {
    if (isDefaultValueInvalid(rule)) {
      return `Value is required for ${rule.priceType} when Mapping Type is Default and Price Adjustment is Increase or Decrease.`;
    }
    if (isMappedFieldInvalid(rule)) {
      return `Please select a field for ${rule.priceType} when Price Adjustment is Increase or Decrease.`;
    }
    if (isAdjustmentValueInvalid(rule)) {
      return 'Please provide adjustment values for all modified price types.';
    }
  }
  return null;
};
